import { PupilDuplicateGroup } from "@core/models/domain/pupil-duplicate.domain";

export interface PupilDuplicateState {
  groups: PupilDuplicateGroup[];
  loading: boolean;
  /** At least one load finished, so the lists that hide copies do not reload on every visit. */
  loaded: boolean;
  error: string | null;
  // Id of the group being marked "Not the same child" or losing a copy, so the page can disable its buttons.
  actionInProgressId: string | null;
}

export const initialPupilDuplicateState: PupilDuplicateState = {
  groups: [],
  loading: false,
  loaded: false,
  error: null,
  actionInProgressId: null,
};
